import { UUID } from "../generic/uuid";
import { createVatTaxDtoFromAnalyticVatTaxModel, VatTaxModel } from "./vatTax";
import { OrganisationDto } from "@vini-wine/core-dtos";

export interface OrganisationModel extends UUID {
  // transform
  name: string;
  legalName: string;
  vatTax: VatTaxModel;
}

export const createOrganisationDtoFromAnalyticOrganisationModel = (
  organisation: OrganisationModel,
): OrganisationDto => {
  return {
    legalName: organisation.legalName,
    name: organisation.name,
    uuid: organisation.uuid,
    vatTax: createVatTaxDtoFromAnalyticVatTaxModel(organisation.vatTax),
  };
};
